import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_freight_billing_account_selectorService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { owner_id?: number, account_id?: number, fullTextSearch?: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string, TypeId?: number, Type?: { Id?: number, Name?: string }, AccountsContactsLookup?: { AccountId?: number, ContactId?: number, Contact?: { Id?: number, AddressId?: number, Address?: { Id?: number, AttentionOf?: string, City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string }, OwnersContactsLookup?: { OwnerId?: number, ContactId?: number, Owner?: { Id?: number, LookupCode?: string, Name?: string } }[] } }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_freight_billing_account_selector/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { owner_id?: number, account_id?: number, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string, TypeId?: number, Type?: { Id?: number, Name?: string }, AccountsContactsLookup?: { AccountId?: number, ContactId?: number, Contact?: { Id?: number, AddressId?: number, Address?: { Id?: number, AttentionOf?: string, City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string }, OwnersContactsLookup?: { OwnerId?: number, ContactId?: number, Owner?: { Id?: number, LookupCode?: string, Name?: string } }[] } }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_freight_billing_account_selector/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { owner_id?: number, account_id?: number, fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string, TypeId?: number, Type?: { Id?: number, Name?: string }, AccountsContactsLookup?: { AccountId?: number, ContactId?: number, Contact?: { Id?: number, AddressId?: number, Address?: { Id?: number, AttentionOf?: string, City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string }, OwnersContactsLookup?: { OwnerId?: number, ContactId?: number, Owner?: { Id?: number, LookupCode?: string, Name?: string } }[] } }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_freight_billing_account_selector/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      owner_id?: number, account_id?: number, fullTextSearch?: string    }) {
      return false;
    }
}
